import { useCallback } from 'react';

import { useInstanceId } from '@frontend/hooks';

import { getReferencedByWorkflows, type ReferencedByWorkflow } from '../services/unifiedAgents';

/**
 * Imperative, uncached check for the workflows that reference an agent
 * (OPAL-2322). Fetches fresh at action time (delete-intent / edit-save) so the
 * modal reflects current state rather than a stale cache.
 */
export function useCheckReferencedBy() {
  const { instanceId } = useInstanceId();

  const check = useCallback(
    async (agentId: string): Promise<ReferencedByWorkflow[]> => {
      if (!instanceId) return [];
      const { queryFn } = getReferencedByWorkflows(instanceId, agentId);
      const { workflows } = await queryFn();
      return workflows;
    },
    [instanceId]
  );

  return { check };
}
